import { useEffect, useRef } from "react";
import chatHub from "../services/ChatHub";
import { AIR_ORDER_CHANGE_EVENT } from "../services/orderRealtimeEvents";

export const useAirOrderRealtimeEvents = (onAirOrderChange) => {
  const callbackRef = useRef(onAirOrderChange);

  useEffect(() => {
    callbackRef.current = onAirOrderChange;
  }, [onAirOrderChange]);

  useEffect(
    () => chatHub.subscribe(AIR_ORDER_CHANGE_EVENT, (event) => callbackRef.current?.(event)),
    [],
  );
};
